import React from 'react';

export default function Foooter() {
  return (
   <footer>
     <div className="container">
		  <p>All Rights Reserved © 2024 | <a target="_blank" href="#" title="Muhammad Ramzan Nawab"> MRN</a></p>
	  </div>
   </footer>
  ) 
}
